// src/components/Layout/Layout.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col">
            <Helmet>
                {/* Organization Schema */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "GradPath",
                        "url": "https://gradpath.co.za/",
                        "sameAs": [
                            "https://www.linkedin.com/company/gradpath-south-africa/",
                            "https://www.instagram.com/gradpathza/"
                        ],
                        "logo": "https://gradpath.co.za/logo.png",
                        "description": "South Africa's leading career platform connecting graduates with entry-level jobs, internships, and work-integrated learning opportunities."
                    })}
                </script>
                
                {/* Service Schema */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Graduate Jobs and Internships",
                        "description": "A job board and career platform connecting South African graduates with entry-level jobs, internships, and work-integrated learning opportunities.",
                        "provider": {
                            "@type": "Organization",
                            "name": "GradPath",
                            "url": "https://gradpath.co.za/"
                        },
                        "areaServed": {
                            "@type": "Country",
                            "name": "South Africa"
                        },
                        "serviceType": "Job Board"
                    })}
                </script>

                {/* WebSite Schema */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "GradPath",
                        "url": "https://gradpath.co.za/",
                        "description": "Find entry-level jobs, internships, and work-integrated learning opportunities for graduates in South Africa.",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "https://gradpath.co.za/jobs?search={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    })}
                </script>
            </Helmet>
            <Navbar />
            <main className="flex-grow">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;